export default __webpack_public_path__ + "843bb8476811abf3658ead76552018ed.png";